module.exports = __webpack_public_path__ + "media/images/recruit/top/meetup-fca0c0e391eca8569d5acd7c8bf7364c.png";